import { API_ERROR_STATUS } from 'constants/api';

export const isInvitationEmailMismatch = (error) => error?.status === API_ERROR_STATUS.FORBIDDEN && !error.data?.code;
